import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const MailIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "mail",
  "MailIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M0.666504 2.66669H15.3332V13.3334H0.666504V2.66669ZM3.31624 4.00002L7.99984 7.19316L12.6834 4.00002H3.31624ZM13.9998 4.71626V12H1.99984V4.71626L7.99984 8.80688L13.9998 4.71626Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default MailIcon;
